import React from 'react';
import moment from 'moment';
import { Controller } from 'react-hook-form';
import { InputLabel, FormHelperText } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';

type FormatType = 'dd-MM-yyyy' | 'dd-MM' | 'MM-yyyy';

interface DatePickerFieldProps {
  name: string;
  control: any;
  label: string;
  required?: boolean;
  error?: string;
  className?: string;
  format?: FormatType;
  disableDirection?: 'past' | 'future';
  onChangeCallback?: () => void;
}

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  name,
  control,
  label,
  required = false,
  error = '',
  className,
  format = 'MM-yyyy',
  disableDirection = 'past',
  onChangeCallback
}) => {
  // Determine views and moment format
  let views: ('day' | 'month' | 'year')[] = ['month', 'year'];
  let momentFormat = 'MM-YYYY';
  let placeholder = 'mm-yyyy';

  switch (format) {
    case 'dd-MM-yyyy':
      views = ['day', 'month', 'year'];
      momentFormat = 'DD-MM-YYYY';
      placeholder = 'dd-mm-yyyy';
      break;
    case 'dd-MM':
      views = ['day', 'month'];
      momentFormat = 'DD-MM';
      placeholder = 'dd-mm';
      break;
    case 'MM-yyyy':
    default:
      views = ['month', 'year'];
      momentFormat = 'MM-YYYY';
      placeholder = 'mm-yyyy';
      break;
  }

  return (
    <>
      <InputLabel>
        {label} {required ? '*' : ''}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          const selectedDate = value ? moment(value, momentFormat).toDate() : null;

          return (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                views={views}
                format={format}
                value={selectedDate}
                // On change
                onChange={(date) => {
                  if (date) {
                    const formatted = moment(date).format(momentFormat);
                    onChange(formatted);
                  } else {
                    onChange('');
                  }
                  if (onChangeCallback) {
                    onChangeCallback(); // Call the callback when date changes
                  }
                }}
                // Past and future date cannot select condition
                shouldDisableDate={(date) => {
                  const today = moment().startOf('day');
                  // if (disableDirection === 'past') {
                  //   return moment(date).isBefore(today); // disable past
                  // }
                  if (disableDirection === 'future') {
                    return moment(date).isAfter(today); // disable future
                  }
                  return false;
                }}
                // SlotP rops
                slotProps={{
                  actionBar: { actions: ['clear'] },
                  desktopPaper: {
                    className: `selectedSectionsClass ${className ? ' ' + className : ''}`
                  },
                  textField: {
                    inputProps: { placeholder: placeholder }
                  }
                }}
              />

              {/* Error msg */}
              <FormHelperText error>{error}</FormHelperText>
            </LocalizationProvider>
          );
        }}
      />
    </>
  );
};

export default DatePickerField;
